import { render } from "./MessageRead.vue?vue&type=template&id=00d7c1cd&scoped=true&ts=true"
import script from "./MessageRead.vue?vue&type=script&lang=ts"
export * from "./MessageRead.vue?vue&type=script&lang=ts"

import "./MessageRead.vue?vue&type=style&index=0&id=00d7c1cd&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d7c1cd"]])

export default __exports__